/**
 * Created by mauget on 12/20/15.
 */
// CrudController.js
import { Model }        from 'backbone';
import $                from 'jquery';
import _                from 'lodash';
import listService      from 'ListService';
import eventBus         from 'EventBus.js';
import constants        from 'Constants';
import BaseController   from 'BaseController';
import focusController  from 'FocusController';
import factoryService   from 'FactoryService';
import Immutable        from 'immutable';
import LineModel        from 'LineModel.js';
import ConnectionVO     from 'ConnectionVO.js';
import { ConnectionArrowClass } from 'shapelib/ConnectionArrowClass.js';
import undoService              from 'UndoService.js'
import fabric                   from  'fabric.js/dist/fabric.require';
import connectionController     from 'ConnectionController.js';
import commandGenericFactory    from 'CommandGenericFactory.js';
import util                     from '../service/util/Util.js';
import objectUtil               from 'util/ObjectUtil.js';
import dialogViewExt            from 'common-views/DialogViewExt.js';
import userService              from 'UserService';
import textConstants            from 'TextConstants';
import behaviorHelperService    from 'BehaviorHelperService.js';
import sequenceService from "../service/SequenceService";
import notificationService from "../service/NotificationService";
import utilMobile from "../mobile/commons/MobileGeneralFunctions";
import pasteCommandService from 'PasteCommandService';
import mobileListService from "../service/mobile/MobileListService";


//=============================================================================
// Contains methods that operate on whatever controls are selected.
// Actions include delete, copy, cut, ...
//=============================================================================
class CrudController extends BaseController {

    constructor() {
        super();

        // So tests can guarantee  our instance hierarchy is a singlton
        CrudController.instanceCount = CrudController.instanceCount === undefined ? 1 : CrudController.instanceCount + 1 ;
    }

    //------------ For tests asserting extender is a singlton: ---

    static get instanceCount() { return CrudController._instanceCount; }

    static set instanceCount(arg) { CrudController._instanceCount = arg; }

    get instanceCount() { return CrudController.instanceCount; }

    //----------- End test supports --------------------------

    //==================================================
    // Give PF page the focus unless it has it.
    //==================================================
    _focusToPage() {

        const $page = $(constants.PAGESEL_ID);
        if (!$page.is(':focus') ) {
            $page.trigger(constants.EV_FOCUS);
        }
    }

    //==================================================
    // Removes page for current page ID, along  with all
    // controls for that page. Note that it's okay
    // to remove the final page.
    //==================================================
    deletePage() {
        const currentPageId = listService.currentPageId;
        const page = listService.getPage(currentPageId);

        let mobileObjectsByPageId = listService.mobileObjectsByPageId(currentPageId);
        let mobileNewObjectsByPageId = listService.mobileNewObjectsByPageId(currentPageId);

        if (mobileObjectsByPageId && mobileObjectsByPageId.size) {

            let someElementIsNewObject = mobileObjectsByPageId.filter(controlA => mobileNewObjectsByPageId.some(controlB => controlA.id === controlB.id));

            if(someElementIsNewObject && someElementIsNewObject.size === 0){
                setTimeout(function () {
                    notificationService.info(`${page.model.get("name")} has been deleted. This change will affect Desktop and Mobile app design.`);
                },2000);
            }
        }

        if (mobileNewObjectsByPageId && mobileNewObjectsByPageId.size) {
            listService.removeAllNewObjectsByPageId(currentPageId);
        }

        let behaviorsReference = this.removeObjectFromCommandsReference(currentPageId);
        behaviorsReference = behaviorsReference.concat(this.pagesReferenceInButtons(currentPageId));

        if (behaviorsReference.length > 0) {
            this.showMessageReferencedObjectsInBehaviors(behaviorsReference, false, "page");
        }

        $(document).trigger(constants.EV_PAGE_DELETE_CURRENT);


        //Check if setting is set to false or it is still not set at all
        if (!util.isTrue(userService.userSettings.attributes._edPaDlWa)) {
            const afterDelete = (model) => {
                // check for checked property, set the user settings
                if (model.get('checked')) {
                    userService.userSettings.attributes._edPaDlWa = 'true';
                } else {
                    userService.userSettings.attributes._edPaDlWa = 'false';
                }
            };
            //Setting up the modal
            const attributes = {
                title: textConstants.EDITOR_DELETE_PAGE_TITLE,
                text: textConstants.EDITOR_DELETE_PAGE_TEXT,
                checkboxText: textConstants.EDITOR_DELETE_PAGE_CHECKBOX_TEXT,
                height: 275,
                success: afterDelete
            };
            //Rendering the modal
            const dlg = new dialogViewExt({ model: new Model(attributes) }).render();
        }
    }

    removeChildFromGroupModel(groupId, childId) {
        const parentGroup = listService.getObject(groupId);
        
        // PF-2665: Return if the parent of the control no longer exist (parent must likely have been removed from the list)
        if (!parentGroup) { return; }
        const children = parentGroup.model.get('childList');
        for (var i = 0; i < children.length; i++) {
            if (children[i].attributes.id === childId) {
                break;
            }
        }
        children.splice(i,1);
    }

    deleteChildObject(view, id) {
        const self = this;

        // #PF-3485 Silencing event as in other case it will be handled by the ControlModel's Property Change Undo listener.s
        view.model.set({
            deleted: true,
            undoEvent: 'delete'
        }, {silent: true});

        // Remove view
        view.unrender();
        const targetObj = listService.getObject(id);
        const targetBehaviors = listService.getBehaviorInstanceByObject(id);
        const groupId = targetObj.groupId;

        
        // if this is a Group
        if (constants.GROUP_KEYS.contains(view.model.get('factoryKey'))) {
            Immutable.List(view.model.get('childList')).map(v => {
                const vw = listService.getObject(v.get('id'));
                if(vw){
                    self.deleteChildObject(vw,v.get('id'));
                }
            });
        }

        listService.destroyObject(targetObj.id, {silent: true});
        //$(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['delete','object', view.model.get('id'), '', view._pageId ]);
        // remove control from parent group
        if (groupId) {
            const parentGroup = listService.getObject(groupId);
            const children = parentGroup.model.get('childList');
            for (var i = 0; i < children.length; i++) {
                const childId = children[i].attributes ? children[i].attributes.id : children[i].id;
                if (childId === id) {
                    break;
                }
            }
            children.splice(i,1);
        }

        if (targetBehaviors.size > 0) {
            this.removeBehaviors(targetBehaviors, view._pageId);

            // TODO - check user setting to display this or not
            const displayDlg = true;
            if (displayDlg) {

                this.successDelete = (model) => {
                    //console.log(model);
                    // check for checked property, set the user settings
                    if (model.get('checked')) {
                        //update settings for this

                    }
                };
                this.deletingBehaviors = true;
            }
        }
    }


    // This method may be called by another that is already tracking Undo, so the undoSupport parameter allows it to be overriden.
    deleteObject(view, id, undoSupport = true,isCut = false, showMobileMessage = true) {
        const self = this;
        view.model.set({
            deleted: true,
            undoEvent: 'delete'
        }, {silent: true});

        // Remove view
        view.unrender();

        const targetObj = listService.getObject(id);

        // #PF-2078
        // Placing the behaviors and its connections into the environment of the Javascript function to restore it later.
        const targetBehaviors = listService.getBehaviorInstanceByObject(id);
        const targetBehaviorsMap=listService.behaviorCommands;
        const targetBehaviorConnectionsMap=listService.behaviorConnections;
        const groupId = targetObj.groupId;
        const metaData = listService.getReportingMetaData(targetObj.id);

        const childList = [];
        const childListView = [];
        if (targetObj.model.get('childList')) {
            _.forEach(targetObj.model.get('childList'), child => {
                childList.push(child);
                childListView.push(listService.getObject(child.id || child.get('id')));
            });
        }

        if(utilMobile.objectInMobileDesign(targetObj.id) && showMobileMessage){
            notificationService.info( `${targetObj.model.get("name")} has been deleted. This change will affect Desktop and Mobile app design.`);
        }

        if (undoSupport) {
            undoService.add({
                undo: () => {
                    listService.injectObject(targetObj, {silent: true});
                    targetObj.listenTo(targetObj.model, 'change', targetObj.render);
                    targetObj.render();
                    if (metaData){
                        listService.addReportingMetaData(metaData);
                    }
                    $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['add', 'object', view.model.get('id'), view.model.get('name'), view._pageId]);

                    // add back to group
                    if (groupId) {
                        const parentGroup = listService.getObject(groupId);
                        const children = parentGroup.model.get('childList');
                        children.push(targetObj.model);
                    }

                    //  PF-2704 Processing for CheckboxGroup and RadioGroup//
                    if (targetObj.model.get('childList')) {
                        targetObj.model.set('childList', childList, {silent:true});
                        _.forEach(childListView, child =>{
                            child.listenTo(child.model, 'change', child.render);
                            listService.addObject(child.id, child, {pageId: child.model.get('pageId')});
                            child.render();
                        });
                    }
                    utilMobile.addedNewObjectToDesktopCanvas(targetObj);
                   
                    listService.reorderTabIndexes(view.id);

                    this.restoreBehaviors(targetBehaviors, view._pageId,targetBehaviorsMap,targetBehaviorConnectionsMap);
                    eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
                    eventBus.trigger(constants.EV_UPDATE_BEHAVIORS_ONLY);
                },
                redo: () => {
                    view.unrender();
                    listService.destroyObject(targetObj.id, {silent: true});
                    listService.deleteReportMetaData( targetObj.id );
                    $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['delete', 'object', view.model.get('id'), '', view._pageId]);

                    // remove control from parent group
                    if (groupId) {
                        const parentGroup = listService.getObject(groupId);
                        const children = parentGroup.model.get('childList');
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].attributes.id === id) {
                                break;
                            }
                        }
                        children.splice(i, 1);
                    }

                    if (targetObj.model.get('childList')) {
                        targetObj.model.set('childList', childList, {silent:true});
                        _.forEach(targetObj.model.get('childList'), child => {

                            //PF-3485 Deleting the event raise, as destroy object will do the work.
                            listService.destroyObject(child.id, { silent: false });
                        })
                    }

                    listService.reorderTabIndexes(view.id);

                    this.removeBehaviors(targetBehaviors, view._pageId);
                    eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
                    eventBus.trigger(constants.EV_UPDATE_BEHAVIORS_ONLY);
                }
            }, isCut ? textConstants.UNDO_CUT : textConstants.UNDO_DELETE);
        }

        // if this is a Group
        if (constants.GROUP_KEYS.contains(view.model.get('factoryKey'))) {
            Immutable.List(view.model.get('childList')).map(v => {
                const vw = listService.getObject(v.id || v.get('id'));
                if(vw){
                    self.deleteChildObject(vw,v.id || v.get('id'));
                } 
            });
        }

        listService.destroyObject(targetObj.id, {silent: false});
        listService.deleteReportMetaData( targetObj.id );

        //$(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['delete','object', view.model.get('id'), '', view._pageId ]);
        // remove control from parent group
        if (groupId) {
            this.removeChildFromGroupModel(groupId, id);
        }

        
        listService.reorderTabIndexes('', view);
        const behaviorList = listService.getBehaviorsByObjectId(id);
        if (behaviorList.length > 0) {
            this.removeBehaviors(targetBehaviors, view._pageId);

            // TODO - check user setting to display this or not
            const displayDlg = true;
            if (displayDlg) {

                this.successDelete = (model) => {
                    //console.log(model);
                    // check for checked property, set the user settings
                    if (model.get('checked')) {
                        //update settings for this

                    }
                };
                this.deletingBehaviors = true;
            }
        }

        // PF-2524: Update parent's minimu width and height based on it's remaining children
        listService.calculateGroupDimensions(groupId);
        eventBus.trigger(constants.EV_DELETE_TREE_FILTER);

        eventBus.trigger('selectPage');
    }

    showMessageReferencedObjectsInBehaviors(referencedBehaviors, multiple = false, isPage){
        
        if (referencedBehaviors.length > 0  && !util.isTrue(userService.userSettings.attributes._edObDlWa)) {
            
            const afterDelete = (model) => {
                // check for checked property, set the user settings
                if (model.get('checked')) {
                    userService.userSettings.attributes._edObDlWa = 'true';
                } else {
                    userService.userSettings.attributes._edObDlWa = 'false';
                }
            };
           
            const behaviors = referencedBehaviors.join("<br />");
            let text =   `The deleted ${isPage ? 'page was' : multiple ? "object's were" : "object was"}`;
            text = `${text} referenced by the following behaviors, 
                            which may no longer work:<br /><br /> ${behaviors}`;

            //Setting up the modal
            const attributes = {
                title: textConstants.EDITOR_DELETE_PAGE_TITLE,
                text: text,
                checkboxText: textConstants.EDITOR_DELETE_PAGE_CHECKBOX_TEXT,
                height: 275,
                success: afterDelete
            };
            //Rendering the modal
            const dlg = new dialogViewExt({ model: new Model(attributes) });
            dlg.render();
        }
    }

    pagesReferenceInButtons(deletedPageId){

        const pageButtons = listService.getObjectByFactoryKey("control_page_button");
        const printButtons = listService.getObjectByFactoryKey("control_print_button");
        const allButtons = pageButtons.concat(printButtons);
        const relatedBehaviors = [];

        const isObjectRelated = (related, objId) => {
            const array = related && !Array.isArray(related) ?  related.split(",") : related;
            return array ? array.includes(objId) : false;
        };

        allButtons.forEach((button) => {
            const isRelated = isObjectRelated(button.model.get("relatedPages"), deletedPageId);

            if(isRelated){
                relatedBehaviors.push(`${button.model.get('name')} - Specific`);

                //Remove the page references from the buttons
                if(button.model.get("page")){
                    button.model.set("page", "" , {silent:true});
                }

                if(button.model.get("pageIds")){

                    let pageIds = button.model.get("pageIds").split(",");
                    pageIds = pageIds.filter((page) => { return page !== deletedPageId; });
                    pageIds = pageIds && pageIds.length ? pageIds.join(",") : "";

                    button.model.set("pageIds", pageIds, {silent:true});
                }

                button.model.set("relatedPages", "", {silent:true});
            }

        });

        return relatedBehaviors;
    }

    removeObjectFromCommandsReference(deletedObjectId){

        const commands = listService.behaviorCommands;
        const isObjectRelated = (related, objId) => {
            const array = related && !Array.isArray(related) ?  related.split(",") : related;
            return array ? array.includes(objId) : false;
        };

        const isConnectionRelated = (request, objId) => {
            if (request !== undefined) {
                const sendParameters = request.Send.parameter.filter(p => p !== undefined && p._value !== '').map(p => p._value.includes('$') ? p._value.split('$')[0] : p._value);
                const receiveParameters = request.Receive.parameter.filter(p => p !== undefined && p._value !== '').map(p => p._value.includes('$') ? p._value.split('$')[0] : p._value);           

                const sendArray = sendParameters && !Array.isArray(sendParameters) ? sendParameters.split(",") : sendParameters;
                const receiveArray = receiveParameters && !Array.isArray(receiveParameters) ? receiveParameters.split(",") : receiveParameters;

                const isInSendArray = sendArray ? sendArray.includes(objId) : false;
                const isInReceiveArray = receiveArray ? receiveArray.includes(objId) : false;

                return isInSendArray || isInReceiveArray;
            }

            return false;
        };

        const relatedBehaviors = [];

        commands.forEach((command) => {
            console.log(command);
            const isRelated = isObjectRelated(command.model.get('relatedFields'), deletedObjectId);
            // PF-9577 Validate if object is related to any connection
            const isConRelated = isConnectionRelated(command.model.attributes.Request, deletedObjectId);

            if(isRelated || isConRelated){              
                const behavior = listService.getBehaviorInstance(command.behaviorInstanceId);
                if(behavior){
                    relatedBehaviors.push(`${behavior.get('owner')} - ${behavior.get('name') || behavior.get('text')}`);
                    listService.unsetPageOriginalItems(behavior.get('pageId')); //Removed parsed items for the page, otherwise the behavior won't be updated
                    if (typeof behavior.get('parsedItem') !== 'undefined'){
                        behavior.unset('parsedItem');
                    }
                }
            }
        });

        return relatedBehaviors;
    }

    deleteSelectedOnMobile(){
        listService.selected.map((view, id) => {
            if (view) {
                const mobileObject = listService.getMobileObject(id);
                const sectionId = mobileObject.sectionId;
                listService.deleteMobileObjectbyId(id);
                mobileListService.deleteMobileControlbyId(id);
                mobileListService.getMobileControl(sectionId).render();
            }
        });
    }

    //==================================================
    // Removes selected controls from the page and
    // from the object list.
    //==================================================
    deleteSelected(isCut=false) {
        this.deletingBehaviors = false;
         if(listService.selected.size === 1) {
            let behaviorsReference = [];
      
            listService.selected.map((view, id) => {
                if (view) {
                    if (view.model.get('childList')) {
                        _.forEach(view.model.get('childList'), child => {
                            $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['delete', 'object', child.id || child.get('id'), '', view._pageId]);
                        });
                    }

                    // PF-2665: Make sure the node to be deleted still exists... it might have been deleted through a parent's at this point
                    if (listService.getObject(id)) {
                        if(view.model.get('factoryKey') === 'control_radio_button'){
                            sequenceService.removeRadioButtons(1);
                        }
                        this.deleteObject(view,id,true,isCut);
                        behaviorsReference = behaviorsReference.concat(this.removeObjectFromCommandsReference(id));
                    
                        let lastSourceId = view.model.get('dataSourceId');
                        if (lastSourceId) {
                            let ds = listService.getDataSources(lastSourceId);
                            if (ds && ds.uses) {
                                ds.uses -= 1;
                            }
                        }
                    }
                }
            });
            if (this.deletingBehaviors) {
                const attributes = {
                    title: 'Delete',
                    text: 'You have deleted a control with an associated behavior. As a result the behavior has also been deleted. This action can be undone by selecting the menu item Edit | Undo.',
                    checkboxText: "Don't show this message again",
                    height: 275,
                    success: this.successDelete
                };

                const dlg = new dialogViewExt({model: new Model(attributes)}).render();
            }

             behaviorsReference = Array.from(new Set(behaviorsReference));

             if (behaviorsReference.length > 0) {
                 this.showMessageReferencedObjectsInBehaviors(behaviorsReference, false);
             }

            listService.clearSelected();
            let currentSize = this.selectedCount;
            util.validateMenuItems(currentSize);
        }
        else {

            // #PF-2698 Performing a backup of current objects in case that an undo is requested.
            let auxSelected=Immutable.Map(listService.selected);
            let targetBehaviorsMap=Immutable.Map(listService.behaviorCommands);
            let targetBehaviorConnectionsMap=Immutable.Map(listService.behaviorConnections);

            let currentTargetObjects=Immutable.Map();
            let currentTargetBehaviors=Immutable.Map();
            let currentGroupIds=Immutable.Map();
            let currentMetaData=Immutable.Map();

            // Backup of Behaviors and Report Metadata
            auxSelected.map((view,id) => {
                let currentTargetObject=listService.getObject(id);
                currentTargetObjects = currentTargetObjects.set(id,currentTargetObject);
                currentTargetBehaviors = currentTargetBehaviors.set(id,listService.getBehaviorInstanceByObject(id));
                currentGroupIds = currentGroupIds.set(id,currentTargetObject.groupId);
                currentMetaData = currentMetaData.set(id,listService.getReportingMetaData(currentTargetObject.id));
            });
            this.removeMultipleObjects(auxSelected);

            undoService.add({
                undo: () => {
                   this.restoreDeletedObjects(auxSelected,currentTargetObjects,currentGroupIds,currentMetaData,currentTargetBehaviors,targetBehaviorsMap,targetBehaviorConnectionsMap);
                },
                redo: () => {
                    this.removeMultipleObjects(auxSelected);
                }
            },textConstants.UNDO_DELETE_MULTIPLE);
        }
    }

    restoreDeletedObjects(auxSelected,currentTargetObjects,currentGroupIds,currentMetaData,currentTargetBehaviors,targetBehaviorsMap,targetBehaviorConnectionsMap){
        auxSelected.map((view, id) => {
            // Placing the behaviors and its connections into the environment of the Javascript function to restore it later.
            let currentTargetObject=currentTargetObjects.get(id);

            let currentGroupId=currentGroupIds.get(id);

            view.listenTo(currentTargetObject.model, 'change', currentTargetObject.render);
            view.render();
            listService.injectObject(currentTargetObject, {silent: true});
            if (currentMetaData.get(id)){
                listService.addReportingMetaData(currentMetaData.get(id));
            }
            $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['add', 'object', view.model.get('id'), view.model.get('name'), view._pageId]);

            // add back to group
            if (currentGroupId) {
                const parentGroup = listService.getObject(listService.getObject(currentGroupId));
                const children = parentGroup.model.get('childList');
                children.push(currentTargetObject.model);
            }

            utilMobile.addedNewObjectToDesktopCanvas(currentTargetObject);
           
            listService.reorderTabIndexes(view.id);
            this.restoreBehaviors(currentTargetBehaviors.get(id), view._pageId,targetBehaviorsMap,targetBehaviorConnectionsMap);
            focusController.selectionRectangle(view.id, true);
            listService.addToSelected(id);
        });
    }

    removeMultipleObjects(auxSelected){//
        let deletedMobileItems = 0;
        let behaviorsReference = [];

        auxSelected.map((view, id) => {
            if (view) {
                if (view.model.get('childList')) {
                    _.forEach(view.model.get('childList'), child => {
                        $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['delete', 'object', child.get('id'), '', view._pageId]);
                    });
                }

                // PF-2665: Make sure the node to be deleted still exists... it might have been deleted through a parent's at this point
                if (listService.getObject(id)) {
                    if(view.model.get('factoryKey') === 'control_radio_button'){
                        sequenceService.removeRadioButtons(1);
                    }
                    
                    if(utilMobile.objectInMobileDesign(id)){
                        deletedMobileItems++;
                    }

                    this.deleteObject(view, id,false,false,false);

                    behaviorsReference = behaviorsReference.concat(this.removeObjectFromCommandsReference(id));
                    
                    let lastSourceId = view.model.get('dataSourceId');
                    if (lastSourceId) {
                        let ds = listService.getDataSources(lastSourceId);
                        if (ds && ds.uses) {
                            ds.uses -= 1;
                        }
                    }
                }
            }
        });
        behaviorsReference = Array.from(new Set(behaviorsReference));

        if(behaviorsReference.length > 0){
            this.showMessageReferencedObjectsInBehaviors(behaviorsReference, true);
        }

        listService.clearSelected();
        let currentSize = this.selectedCount;
        util.validateMenuItems(currentSize);

        if(deletedMobileItems > 0){
            notificationService.info( 'Multiple objects have been deleted. This change will affect Desktop and Mobile app design.');
        }
                   
    }

    removeBehaviors(behaviorInstances, pageId) {
        behaviorInstances.map( (instance, id) => {
            listService.destroyBehaviorInstance(id);
        });
    }

    restoreBehaviors(behaviorInstances, pageId,behaviorMap,behaviorConnectionsMap) {
        behaviorInstances.map( (instance, id) => {
            listService.injectBehaviorInstance(instance);

            // Restoring the Maps from the Undo functionality.
            listService.setBehaviorCommands(behaviorMap);
            listService.setBehaviorConnections(behaviorConnectionsMap);
            //$(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['add','behavior', id, '',  pageId ]);
        });
    }


    _addConnectionArrow(activeObject) {

        const connId = activeObject.model.get('id');

        // remove connection from canvas object array
        const srcObject = listService.getCanvasObjectById( activeObject.model.get('srcWidgetModel').id );


        if (srcObject && srcObject.connection) {
            srcObject.connection.push(activeObject.model.line);
        }

        listService.addBehaviorConnection(activeObject);
        listService.fcanvas.add(activeObject);


    }

    _removeConnectionArrow(object, id, kind) {
        const connId = id ? id : object.model.get('id');
        const activeObject = listService.getCanvasObjectById(connId);
        if (activeObject) {
            // remove connection from canvas object array
            const srcObject = listService.getCanvasObjectById(activeObject.model.get('srcWidgetModel').id);
            const destObject = listService.getCanvasObjectById(activeObject.model.get('destWidgetModel').id);

            if (srcObject && srcObject.connection) {
                let connIndex = -1;
                for (let x = 0; x < srcObject.connection.length; x++) {
                    if (srcObject.connection[x].line.model.get('id') === connId) {
                        connIndex = x;
                        break;
                    }
                }

                if (connIndex > -1) {
                    srcObject.connection.splice(connIndex, 1);
                }
            }

            if (destObject && destObject.connection) {
                let connIndex = -1;
                for (let x = 0; x < destObject.connection.length; x++) {
                    if (destObject.connection[x].line.model.get('id') === connId) {
                        connIndex = x;
                        break;
                    }
                }

                if (connIndex > -1) {
                    destObject.connection.splice(connIndex, 1);
                }
            }
        }

        let connection;
        if (kind === 'B') {
            connection = listService.destroyBehaviorConnnection( connId );
        } else {
            connection = listService.deleteWorkflowPath({id: connId});
        }
        listService.fcanvas.remove(activeObject);
        return connection;
    }

    deleteSelectedBehaviors(isCut=false){
        const locked = true;
        // Getting the current canvas instance
        const canvas = listService.fcanvas;

        // Disabling drawing mode on canvas.
        canvas.isDrawingMode=false;

        // Getting both the active object(One element is selected) and active group (more than 1 element is selected).
        const
            activeObject = canvas.getActiveObject(),
            activeGroup = canvas.getActiveGroup();

        let connections = [];


        // If there is just one, remove it from the canvas and from the map collection in the model.
        if (activeObject) {
            if (this._isConnector(activeObject) ) {
                const conn = this._removeConnectionArrow(activeObject, activeObject.model.get('id'), constants.KIND_BEHAVIORS);
                connections.push(conn);
            } else {
                canvas.remove(activeObject);
            }
            const behConns = listService.destroyBehaviorObject(activeObject.model.get('id'));
            Array.prototype.push.apply(connections, behConns);
        }

        // Multiple, iterate the multiple selected controls and delete them one by one.
        else if (activeGroup) {
                const objectsInGroup = activeGroup.getObjects();
                canvas.discardActiveGroup();
                objectsInGroup.forEach( object => {
                    if (this._isConnector( object )) {
                        const conn = this._removeConnectionArrow(object, object.model.get('id'), constants.KIND_BEHAVIORS);
                        connections.push(conn);
                    } else {
                        canvas.remove(object);
                        const behConns = listService.destroyBehaviorObject(object.model.get('id'));
                        Array.prototype.push.apply(connections, behConns);
                    }
                });
        }
        eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
       
        undoService.add({
            undo: ()=>{
                if (activeObject) {
                    if (this._isConnector(activeObject) ) {

                    } else {
                        // MAY HAVE TO CREATE A NEW Command Object here and copy model over. Context is lost on undo.
                        const vw = commandGenericFactory.createView(activeObject.model.get('factoryKey'), {left: 1, top: 1});
                        vw.model = activeObject.model;

                        listService.addBehaviorObject(vw.model.get('id'), vw);
                        vw.render();

                    }

                } else if (activeGroup) {
                    const objectsInGroup = activeGroup.getObjects();
                    //canvas.discardActiveGroup();
                    objectsInGroup.forEach( object => {
                        if (this._isConnector( object )) {
                            //listService.addBehaviorConnection(object);
                        } else {
                            const vw = commandGenericFactory.createView(object.model.get('factoryKey'), {left: 1, top: 1});
                            vw.model = object.model;

                            listService.addBehaviorObject(vw.model.get('id'), vw);
                            vw.render();
                        }
                    });

                }

                // process connections
                _.forEach(connections, function (conn) {
                    if (conn) {
                        listService.addBehaviorConnection(conn);

                        if (listService.mainKind === constants.KIND_BEHAVIORS) {
                            // find src widget and add to connections
                            const srcObject = listService.getCanvasObjectById(conn.model.get('srcWidgetModel').id);

                            const cinfo = util.getCommandCoordInfo(conn);

                            const opts = constants.LINE_MODEL_OPTIONS;
                            opts.model = conn.model;
                            const line = new ConnectionArrowClass(cinfo.coords, opts );
                            line.model = conn.model;

                            if (!srcObject.connection) {
                                srcObject.connection = [];
                            }
                            srcObject.connection.push({line: line, end: constants.A_END});

                            // find dest widget, add to connections.
                            const destObject = listService.getCanvasObjectById(conn.model.get('destWidgetModel').id);
                            if (!destObject.connection) {
                                destObject.connection = [];
                            }
                            destObject.connection.push({line: line, end: constants.B_END});

                            line.srcId = conn.srcCommand.id;
                            line.destId = conn.destCommand.id;
                            listService.fcanvas.add(line);
                            line.setCoords();
                        }
                    }

                })
                eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
            },
            redo: ()=>{
                if (activeObject) {
                    if (this._isConnector(activeObject) ) {
                        const curObject = listService.getCanvasObjectById(activeObject.model.get('id'));
                        const conn = this._removeConnectionArrow(curObject, activeObject.model.get('id'), constants.KIND_BEHAVIORS);
                        connections.push(conn);
                    } else {
                        // activeObject no londer has correct ref to Canvas object, need to find it another way.
                        const widget = connectionController.findWidgetById(activeObject.model.get('id'));
                        listService.fcanvas.remove(widget);
                        const behConns = listService.destroyBehaviorObject(activeObject.model.get('id'));
                        Array.prototype.push.apply(connections, behConns);
                    }

                }

                // Multiple, iterate the multiple selected controls and delete them one by one.
                else if (activeGroup) {
                    const objectsInGroup = activeGroup.getObjects();
                    canvas.discardActiveGroup();
                    objectsInGroup.forEach( object => {
                        if (this._isConnector( object )) {
                            const conn = this._removeConnectionArrow(object, object.model.get('id'), constants.KIND_BEHAVIORS);
                            connections.push(conn);
                        } else {
                            const widget = connectionController.findWidgetById(object.model.get('id'));
                            listService.fcanvas.remove(widget);
                            const behConns = listService.destroyBehaviorObject(object.model.get('id'));
                            Array.prototype.push.apply(connections, behConns);
                        }
                    });
                }
                eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
            }

        }, isCut ? textConstants.UNDO_CUT : textConstants.UNDO_DELETE);

        // PF-2000: Show default page properties
        listService.fcanvas.trigger('mouse:down').trigger('mouse:up');  
    }

    deleteSelectedWorkflowObjects(isCut=false) {
        const locked = true;
        // Getting the current canvas instance
        let canvas=listService.fcanvas;

        // Disabling drawing mode on canvas.
        canvas.isDrawingMode=false;

        // Getting both the active object(One element is selected) and active group (more than 1 element is selected).
        const
            activeObject = canvas.getActiveObject(),
            activeGroup = canvas.getActiveGroup();

        let connections = [];

        // If there is just one, remove it from the canvas and from the map collection in the model.
        if (activeObject) {
            if (this._isConnector(activeObject)) {
                const conn = this._removeConnectionArrow(activeObject, activeObject.model.get('id'), constants.KIND_WORKFLOW);
                connections.push(conn);
            } else {
                canvas.remove(activeObject);
                const wfConns = listService.deleteWorkflowObject(activeObject);
                Array.prototype.push.apply(connections, wfConns);
            }
        }

        //If its more than one, loop to the multiple selected controls and delete them one by one.
        else if (activeGroup) {
            var objectsInGroup = activeGroup.getObjects();
            canvas.discardActiveGroup();
            objectsInGroup.forEach(object => {
                if (this._isConnector( object )) {
                    const conn = this._removeConnectionArrow(object, object.model.get('id'), constants.KIND_WORKFLOW);
                    connections.push(conn);
                } else {
                    canvas.remove(object);
                    const wfConns = listService.deleteWorkflowObject(object);
                    Array.prototype.push.apply(connections, wfConns);
                }
            });
        }

        undoService.add({
            undo: ()=> {
                if (activeObject) {
                    if (this._isConnector(activeObject)) {

                    } else {
                        const vw = commandGenericFactory.createWorkflowView(activeObject.model.get('factoryKey'), {left: 1, top: 1});
                        vw.model = activeObject.model;
                        vw.id = activeObject.model.get('id');

                        listService.addWorkflowObject(vw);
                        vw.render();
                    }
                }

                //If its more than one, loop to the multiple selected controls and delete them one by one.
                else if (activeGroup) {
                    var objectsInGroup = activeGroup.getObjects();
                    canvas.discardActiveGroup();
                    objectsInGroup.forEach(object => {
                        if (this._isConnector( object )) {

                        } else {
                            const vw = commandGenericFactory.createWorkflowView(object.model.get('factoryKey'), {left: 1, top: 1});
                            vw.model = object.model;
                            vw.id = object.model.get('id');

                            listService.addWorkflowObject(vw);
                            vw.render();
                        }
                    });
                }

                // process connections
                _.forEach(connections, function (conn) {
                    if (conn) {
                        listService.addWorkflowPath(conn);

                        if (listService.mainKind === constants.KIND_WORKFLOW) {
                            // find src widget and add to connections
                            const srcObject = listService.getCanvasObjectById(conn.model.get('srcWidgetModel').id);
                            const cinfo = util.getCommandCoordInfo(conn);
                            const opts = constants.LINE_MODEL_OPTIONS;
                            opts.model = conn.model;
                            const line = new ConnectionArrowClass(cinfo.coords, opts );
                            line.model = conn.model;

                            if (!srcObject.connection) {
                                srcObject.connection = [];
                            }
                            srcObject.connection.push({line: line, end: constants.A_END});

                            // find dest widget, add to connections.
                            const destObject = listService.getCanvasObjectById(conn.model.get('destWidgetModel').id);
                            if (!destObject.connection) {
                                destObject.connection = [];
                            }
                            destObject.connection.push({line: line, end: constants.B_END});

                            line.srcId = conn.srcCommand.id;
                            line.destId = conn.destCommand.id;
                            listService.fcanvas.add(line);
                            line.setCoords();
                        }
                    }

                })
            },
            redo: ()=> {
                if (activeObject) {
                    if (this._isConnector(activeObject)) {
                        const curObject = listService.getCanvasObjectById(activeObject.model.get('id'));
                        const conn = this._removeConnectionArrow(curObject, activeObject.model.get('id'), constants.KIND_WORKFLOW);
                        connections.push(conn);
                    } else {
                        const widget = connectionController.findWidgetById(activeObject.model.get('id'));
                        listService.fcanvas.remove(widget);
                        const wfConns = listService.deleteWorkflowObject(activeObject);
                        Array.prototype.push.apply(connections, wfConns);
                    }
                }
                else if (activeGroup) {
                    var objectsInGroup = activeGroup.getObjects();
                    canvas.discardActiveGroup();
                    objectsInGroup.forEach(object => {
                        if (this._isConnector( object )) {
                            const conn = this._removeConnectionArrow(object, object.model.get('id'), constants.KIND_WORKFLOW);
                            connections.push(conn);
                        } else {
                            const widget = connectionController.findWidgetById(object.model.get('id'));
                            listService.fcanvas.remove(widget);
                            const wfConns = listService.deleteWorkflowObject(object);
                            Array.prototype.push.apply(connections, wfConns);
                        }
                    });
                }

            }
        },isCut ? textConstants.UNDO_CUT : textConstants.UNDO_DELETE);

        // PF-2000: Show default page properties
        listService.fcanvas.trigger('mouse:down').trigger('mouse:up');
    }

    //==================================================
    // Removes selected controls from the page and
    // from the object list, after storing their
    // references in a clipboard implemented by  the
    // listService.
    //==================================================
    cutSelected() {

        listService.copySelected();
        this.deleteSelected(true);
    }

    //==================================================
    // Removes selected controls from the page and
    // from the object list, after storing their
    // references in a clipboard implemented by  the
    // listService.
    //==================================================
    cutSelectedBehaviors() {
        // Not cut for single connector
        const
            activeObject = listService.fcanvas.getActiveObject(),
            isSingleConnector = activeObject && this._isConnector( activeObject );

        if (!isSingleConnector) {
            this.copySelectedBehaviors();
            this.deleteSelectedBehaviors(true);
        }
    }


    //==================================================
    // Selected controls remain on the page, but we
    // store their references in a clipboard implemented
    // by thelistService.
    //==================================================
    copySelected() {

        listService.copySelected();
    }

    copySelectedWorkflowObjects() {
        // Getting the current canvas instance
        let canvas=listService.fcanvas;

        // Disabling drawing mode on canvas.
        canvas.isDrawingMode=false;

        // Getting both the active object(One element is selected) and active group (more than 1 element is selected).
        let activeObject = canvas.getActiveObject(),
            activeGroup = canvas.getActiveGroup();

        if (activeObject) {
            listService.clearWorkflowClipboard();
            listService.copySelectedWorkflowObjects(activeObject)
        } else if (activeGroup) {
            listService.clearWorkflowClipboard();
            listService.copySelectedWorkflowObjects(activeGroup)
        }
    }

    _isConnector(klass) {
        const
            v = klass,
            key = 'factoryKey';
        return v && v.model && constants.CONNECTION_FACTORY_KEY === v.model.get(key);
    }

    copySelectedBehaviors() {
        // Not cut for single connector
        const
            activeObject = listService.fcanvas.getActiveObject(),
            isSingleConnector = activeObject && this._isConnector(activeObject);

        if (!isSingleConnector) {

            // Getting the current canvas instance
            const canvas = listService.fcanvas;

            // Disabling drawing mode on canvas.
            canvas.isDrawingMode = false;

            // Getting both the active object(One element is selected) and active group (more than 1 element is selected).
            const
                activeObject = canvas.getActiveObject(),
                activeGroup = canvas.getActiveGroup();
              
            // Copy any single object if not a connector. We don't paste` orphan connectors, so don't copy one.
            if (activeObject && !this._isConnector(activeObject)) {
                listService.clearBehaviorClipboard();
                listService.copySelectedBehaviors(activeObject);
            } else if (activeGroup) {
                listService.clearBehaviorClipboard();
                listService.copySelectedBehaviors(activeGroup);

                _.forEach(listService.behaviorClipboard.objects, v => {
                    if (this._isConnector(v)) {
                        // Stash ConnectorVO in the connector object for use by future paste
                        const connection = listService.behaviorConnections.get( v.model.get('id') );
                        v.connVO = connection;
                    }
                });
            }
        } else {
            console.log(`===>>> No cuts allowed on single selected connnector <===`)
        }
    }

    //==================================================
    // Controls on the clipboard remain on the page, and
    // new control, with new id, is created and render on
    // the page. Original references keep stored in a
    // clipboard implemented by thelistService.
    //==================================================
    pasteSelected() {
        // TODO If a control is on the page at same (left, top), offset the pasted control
        listService.pasteSelected();
        pasteCommandService.execNextCommand();
    }

    getConnectionCoords(cp1, cp2) {
        const
            strokeWidth = constants.CONN_STROKE_WIDTH, //PF-5194 Giving more width to the stroke so the click does not have to be exactly on the line
            lineOffset = strokeWidth / 2; //Offset created by the stroke width

        let coords = [util.extractNum(cp1.originalLeft) + cp1.radius - lineOffset,
        util.extractNum(cp1.originalTop) + cp1.radius - lineOffset,
        util.extractNum(cp2.originalLeft) + cp2.radius - lineOffset,
        util.extractNum(cp2.originalTop) + cp2.radius - lineOffset];
        
        if (coords[0] === coords[2]) {
            coords[2] += 0.5;
        }
        if (coords[1] === coords[3]) {
            coords[3] += 0.5;
        }

        return coords;
    }

    //========================================================
    // Paste element or elements into canvas position from
    // which they were cut or copied.
    //========================================================
    pasteSelectedBehaviors(){
        const self = this;
        const objects = listService.behaviorClipboard;
        let clipboard = [];
        if (objects.model) {
            clipboard.push(objects);
        } else {
            clipboard = objects._objects;
        }

        let pasteMap = Immutable.Map();

        //PF-2704 Creating a map for storing pasted behaviors for restoring them on the Redo Process.
        let pastedControlMap = Immutable.Map();


        // Pass one: reconstitute the shapes, but not connectors
        clipboard.forEach( v => {
            const factoryKey = v.model.get('factoryKey');
            if (factoryKey !== constants.CONNECTION_FACTORY_KEY) {

                const factoryParams = factoryService.behaviorsFactories[factoryKey];

                const dropPos = {
                    left: util.extractNum(v.model.attributes.x) + 10,
                    top: util.extractNum(v.model.attributes.y) + 10
                };


                const control = factoryParams.factory.createView(factoryKey, dropPos);
                const newId = control.model.get('id');
                const newWidget = control.model.get('widget');
                control.model = v.model.clone();
                if (control.model.get('Parameters')) {
                    control.model.attributes.Parameters = JSON.parse( JSON.stringify( v.model.attributes.Parameters ));
                }
                control.model.id = newId;
                control.model.attributes.id = newId;
                control.model.attributes.widget = newWidget;
                control.model.set({x: dropPos.left, y: dropPos.top}, {silent:true});

                let attributes = Object.assign({}, control.model.attributes);
                for (let p in attributes) {
                    if ( attributes.hasOwnProperty(p) && (attributes[p] !== undefined) ) {
                        //  creating new instances of properties which are objects, arrays or maps
                        control.model.attributes[p] = objectUtil.advancedCopy(attributes[p]);
                    }
                }

                //PF-6628 Remove any references of true/false connectors after paste
                if(factoryKey === "command_simple_branch"){
                    control.model.attributes.trueConnector = "";
                    control.model.attributes.falseConnector = "";
                }

                //PF-8756 Update notifications Ids after paste to avoid duplicates
                if(factoryKey === "command_notify"){
                    const notifications = control.model.get("notifications");

                    if(notifications && Array.isArray(notifications)){
                        notifications.forEach(n => {
                            n.notificationId = sequenceService.nextDomId();
                        });  
                    }                     
                }

                // re establish event listener for this
                control.listenTo(control.model, 'change', control.rerender);
                control.listenTo(control.model, 'widgetTextUpdated', control.rerender);

                pasteMap = pasteMap.set(v.model.get('id'), control.id);
                pastedControlMap = pastedControlMap.set(v.model.get('id'),control);


                listService.addBehaviorObject(control.id, control);
                control.render();

                // Make empty connection container. We set them in another pass
               control.model.get('widget').connection = [];

            }
        });

        const canvas = listService.fcanvas;
        const newConnections = [];
        const newConnectionVO = [];

        // update ref to connection
        pasteMap.forEach( (k,v) => {
            let obj = _.find(clipboard, function(obj) { return obj.model.id === v });


            // get all connection from the original widget that was copied
            let conns = obj.model.get('widget').connection;

            if (conns) {
                _.forEach(conns, function(conn) {

                    if (conn.end === 'A end') {
                        // is the src and dest in the list of widgets copied
                        const sWidget = pasteMap.get(conn.line.srcId);
                        const dWidget = pasteMap.get(conn.line.destId);
                        if (sWidget && dWidget) {
                            const srcObj = listService.getBehaviorObject(sWidget);
                            const destObj = listService.getBehaviorObject(dWidget);

                            // create line

                            const sObject = listService.getCanvasObjectById(sWidget);
                            const dObject = listService.getCanvasObjectById(dWidget);

                            var cp1 = sObject._objects[parseInt(conn.line.model.get('srcDot')) + 1],
                                cp2 = dObject._objects[parseInt(conn.line.model.get('destDot')) + 1];

                            let coords = self.getConnectionCoords(cp1, cp2);
                           
                            let model = new LineModel( { initCoords: coords , name: '', srcDot: conn.line.model.attributes.srcDot, destDot: conn.line.model.attributes.destDot });

                            //We need to set the rest of the attributes from the copied line besides the calculated properties
                            let attributes = Object.assign({}, conn.line.model.attributes);

                            let ignoredAttributes = ['srcDot', 'destDot', 'self', 'controlPoint1', 'controlPoint2'];
                            for (let p in attributes) {
                                if(attributes[p] !== undefined && p !== 'initCoords' && p !== 'name' && !(ignoredAttributes.includes(p)) ){
                                    //for parameters need to be a new object other way references will be the same
                                    if(p === 'Parameters'){
                                        model.attributes.Parameters = JSON.parse( JSON.stringify( conn.line.model.attributes.Parameters ));
                                    }else{
                                        model.attributes[p] = attributes[p];
                                    }
                                }
                            }

                            const locked = true;
                            const opts = constants.LINE_MODEL_OPTIONS;
                            opts.model = model;
                            const line = new ConnectionArrowClass(coords, opts);

                            canvas.add( line );

                            // Record original points and record dot / connection-point within widget, for each end.
                            line.model = model;

                            // update the connection with the new widget id after it was Pasted
                            line.srcId = sWidget;
                            line.destId = dWidget;

                            line.model.attributes.branchBooleanDisplay = conn.line.model.attributes.branchBooleanDisplay;
                            line.model.attributes.destWidgetModel = destObj.model;
                            line.model.attributes.srcWidgetModel = srcObj.model;

                            line.setCoords();

                            // create new VO object
                            const connectionVO = new ConnectionVO( srcObj, destObj, line.model.get('srcDot'), line.model.get('destDot') );
                            line.model.attributes.id =  connectionVO.id;
                            connectionVO.srcCommand = srcObj;
                            connectionVO.destCommand = destObj;


                            if (line.model.attributes.branchBooleanDisplay === 'true') {
                                srcObj.model.attributes.trueConnector = line.model.get('id');
                            }
                            if (line.model.attributes.branchBooleanDisplay === 'false') {
                                srcObj.model.attributes.falseConnector = line.model.get('id');
                            }

                            // Keep track of newly created lines
                            newConnections.push(line);

                            connectionVO.model = line.model;
                            newConnectionVO.push(connectionVO);

                            listService.addBehaviorConnection( connectionVO );

                            srcObj.model.attributes.widget.connection.push({line: line, end: 'A end'});
                            destObj.model.attributes.widget.connection.push({line: line, end: 'B end'});
                        }
                    }
                });

            }

        });

        undoService.add({
            undo: () => {
                // need to know what behaviors / connectors were pasted so we can delete them properly.//
                pasteMap.map( (k,v) => {
                    const obj = listService.getCanvasObjectById(k);
                    listService.fcanvas.remove(obj);
                    listService.destroyBehaviorObject(k);
                    listService.fcanvas.discardActiveGroup();
                    listService.fcanvas.renderAll();
                });

                _.each(newConnections, function (conn) {
                    self._removeConnectionArrow(conn, conn.model.get('id'), constants.KIND_BEHAVIORS);
                });
                eventBus.trigger(constants.EV_UPDATE_BEHAVIORS_ONLY);
            },
            redo: () => {

                pastedControlMap.map( (control,key) => {
                        control.listenTo(control.model, 'change', control.rerender);

                         listService.addBehaviorObject(control.model.get('id'), control, control.behaviorInstanceId );
                         control.render();
                         control.model.get('widget').connection = [];
                         control.model.resetLastState();

                         listService.fcanvas.renderAll();
                });
                _.each(newConnections, function (conn) {
                    const srcObjId = conn.model.get('srcWidgetModel').attributes.id;
                    const destObjId = conn.model.get('destWidgetModel').attributes.id;

                    const srcObj = listService.getBehaviorObject(srcObjId);
                    const destObj = listService.getBehaviorObject(destObjId);

                    // create new VO object
                    const connectionVO = new ConnectionVO( srcObj, destObj, conn.model.get('srcDot'), conn.model.get('destDot') );
                    //conn.model.attributes.id =  connectionVO.id;
                    connectionVO.id = conn.model.get('id');
                    connectionVO.model = conn.model;

                    srcObj.model.attributes.widget.connection.push({line: conn, end: 'A end'});
                    destObj.model.attributes.widget.connection.push({line: conn, end: 'B end'});

                    listService.addBehaviorConnection( connectionVO );
                    // check current mainKind
                    if (listService.mainKind === constants.KIND_BEHAVIORS) {
                        conn.left = conn.x1 < conn.x2 ? conn.x1 : conn.x2;
                        conn.top = conn.y1 < conn.y2 ? conn.y1 : conn.y2;
                        conn.width = Math.abs(conn.x2 - conn.x1);
                        conn.height = Math.abs(conn.y1 - conn.y2);

                        listService.fcanvas.add(conn);
                        conn.setCoords();
                    }
                });
                listService.fcanvas.renderAll();
                eventBus.trigger(constants.EV_UPDATE_BEHAVIORS_ONLY);
            }
        }, textConstants.UNDO_PASTE);

        // Keep Track above of all newly "Pasted" objects. Then select them.
        const objs = [];
        pasteMap.map( (k,v) => {
            const obj = connectionController.findWidgetById(k);
            objs.push(obj);

            const cmdObj = listService.getBehaviorObject(k);
            cmdObj.model.resetLastState();
        });

        _.each(newConnections, function (conn) {
            objs.push(conn);
        });

        // There is already an active group selected in CommandGeneric made by the render above, but
        // when more than 1 object was copied we need to group-select them

        if (objs.length > 1) {
            // They're on the canvas: programatically select them.
            objectUtil.selectCanvasObjects(canvas, objs);
        } else {
            eventBus.trigger('selectSingleItemFromCanvas');
        }

        // PF-2391 allow sucessive pastes
        this.copySelectedBehaviors();

        pasteCommandService.execNextCommand();
        eventBus.trigger(constants.EV_UPDATE_BEHAVIORS_ONLY);
    }



    pasteSelectedWorkflowObjects() {
        const self = this;
        const objects = listService.workflowClipboard;
        let clipboard = [];
        if (objects.model) {
            if(objects.model.get('factoryKey')==='workflow_stage'){
                objects.model.set('isDefault','',{silent:true});
            }
            clipboard.push(objects);
        } else {
            clipboard = objects._objects;
        }

        let pasteMap = Immutable.Map();
        let pasteBehaviorMap = Immutable.Map();

        //PF-2704 Creating a map for storing pasted behaviors for restoring them on the Redo Process.
        let pastedWorkflowMap = Immutable.Map();

        // Pass one: reconstitute the shapes, but not connectors
        clipboard.forEach( v => {
            const factoryKey = v.model.get('factoryKey');
            if (factoryKey !== constants.CONNECTION_FACTORY_KEY) {

                const factoryParams = factoryService.workflowFactories[factoryKey];

                const dropPos = {
                    left: util.extractNum(v.model.attributes.x) + 10,
                    top: util.extractNum(v.model.attributes.y) + 10
                };

                const control = factoryParams.factory.createWorkflowView(factoryKey, dropPos);
                const newId = control.model.get('id');
                const newWidget = control.model.get('widget');
                control.model = v.model.clone();
                control.id = newId;
                control.model.id = newId;
                control.model.attributes.id = newId;
                control.model.attributes.widget = newWidget;
                control.model.set({x: dropPos.left, y: dropPos.top}, {silent:true});
                control.model.attributes.name = control.model.attributes.name;

                let attributes = Object.assign({}, control.model.attributes)
                for (let p in attributes) {
                    if ( attributes.hasOwnProperty(p) && (attributes[p] !== undefined) ) {
                        //  creating new instances of properties which are objects, arrays or maps
                        control.model.attributes[p] = objectUtil.advancedCopy(attributes[p]);
                    }
                }

                // re establish event listener for this
                control.listenTo(control.model, 'change', control.rerender);

                pasteMap = pasteMap.set(v.model.get('id'), control.id);

                pastedWorkflowMap = pastedWorkflowMap.set(v.model.get('id'), control);

                //console.log('Original Control: ' + v.model.attributes.name + ' - ' + v.model.attributes.id);
                //console.log('Copied Control: ' + control.model.attributes.name + ' - ' + newId);

                listService.addWorkflowObject(control);
                control.render();

                // Inject any connections. This makes them "stick", following this widget around the layout
                //control.model.get('widget').connection = conns;
                control.model.get('widget').connection = [];
            } else {
                pasteBehaviorMap = pasteBehaviorMap.set(v.model.get('id'), v);
            }
        });

        // update ref to connection
        const canvas = listService.fcanvas;
        let newConnections = [];
        pasteMap.forEach( (k,v) => {
            let obj = _.find(clipboard, function(obj) { return obj.model.id === v });
            const canvas = listService.fcanvas;

            // get all connection from the original widget that was copied
            let conns = obj.model.get('widget').connection;

            if (conns) {
                _.forEach(conns, function(conn) {

                    if (conn.end === 'A end') {
                        // is the src and dest in the list of widgets copied
                        const sWidget = pasteMap.get(conn.line.srcId);
                        const dWidget = pasteMap.get(conn.line.destId);
                        if (sWidget && dWidget) {
                            const srcObj = listService.getWorkflowStage(sWidget);
                            const destObj = listService.getWorkflowStage(dWidget);

                            // create line
                            const sObject = listService.getCanvasObjectById(sWidget);
                            const dObject = listService.getCanvasObjectById(dWidget);

                            var cp1 = sObject._objects[parseInt(conn.line.model.attributes.srcDot) + 1],
                                cp2 = dObject._objects[parseInt(conn.line.model.attributes.destDot) + 1];

                            let coords = self.getConnectionCoords(cp1,cp2);
                            let model = new LineModel( { initCoords: coords , name: '', srcDot: conn.line.model.attributes.srcDot, destDot: conn.line.model.attributes.destDot });
                            
                            const attributes = Object.assign({}, conn.line.model.attributes);
                            let ignoredAttributes = ['model', 'self', 'controlPoint1', 'controlPoint2'];
                            for (let p in attributes) {
                                // PF-2345 Needs no model copied. Causes pasting workflow with curved path. Model reset below, so copy not needed.
                                if ( attributes[p] !== undefined && p !== 'id'  && !(ignoredAttributes.includes(p)) ) {
                                    if( p === 'destWidgetModel' || p === 'srcWidgetModel'){
                                        model.attributes[p] = Object.assign({}, attributes[p]);
                                    }else{
                                        model.attributes[p] = objectUtil.advancedCopy(attributes[p]);
                                    }
                                }
                            }
                            
                            const locked = true;
                            const opts = constants.LINE_MODEL_OPTIONS;
                            opts.model = model;
                            const line = new ConnectionArrowClass(coords, opts);
                            canvas.add( line );

                            // Record original points and record dot / connection-point within widget, for each end.
                            line.model = model;

                            // update the connection with the new widget id after it was Pasted
                            line.srcId = sWidget;
                            line.destId = dWidget;

                            line.model.attributes.destWidgetModel = destObj.model;
                            line.model.attributes.srcWidgetModel = srcObj.model;
                            line.setCoords();

                            // create new VO object
                            const connectionVO = new ConnectionVO( srcObj, destObj, line.model.get('srcDot'), line.model.get('destDot') );
                            line.model.attributes.id =  connectionVO.id;
                            connectionVO.model = line.model;

                            //Copying behaviors
                            const instance = listService.getBehaviorInstanceByObjectAndBehaviorKey(conn.line.model.get('id'), 'workflow');  
                            if(instance){
                                const instanceToLoad = {
                                    behaviorKey: 'workflow',
                                    objectId:  line.model.attributes.id,
                                    selectedCommand: ''
                                };

                                let behavior = behaviorHelperService.createNewInstanceOnLoad(instanceToLoad);
                                let copiedMap = Immutable.Map();

                                const commands = listService.getBehaviorInstanceObjects(instance.get('id'), null);
                                if(commands.size > 0){
                                    commands.map( (cmd) => {
                                        const control = listService.cloneBehaviorObject(cmd);
                                        listService.addBehaviorObject(control.id, control,  behavior.get('id'));
                                        copiedMap = copiedMap.set(cmd.model.get('id'), control.id);
                                    });
                                }
                                //Creating paths
                                copiedMap.map( (k,v) => {
                                    let behaviorCopied = listService.getBehaviorObject(k);
                                    let connections;
                                    // get all connection from the original widget that was copied
                                    if(!behaviorCopied.model.get('widget')){
                                        connections = behaviorHelperService.createConnections(instance.get('id'), behaviorCopied.model.get('id'))
                                    }else{
                                        connections = behaviorCopied.model.get('widget').connection;
                                    }
                                    if (connections) {
                                        _.forEach(connections, function(connec) {
                                            if (connec.end === 'A end') {
                                                const sourceWidget = copiedMap.get(connec.line.srcId);
                                                const destinationWidget = copiedMap.get(connec.line.destId);
                                                if (sourceWidget && destinationWidget) {
                                                    const sourceObj = listService.getBehaviorObject(sourceWidget);
                                                    const destinationObj = listService.getBehaviorObject(destinationWidget);
                                                    // create line

                                                    const
                                                        strokeWidth = constants.CONN_STROKE_WIDTH, //PF-5194 Giving more width to the stroke so the click does not have to be exactly on the line
                                                        lineOffset = strokeWidth / 2; //Offset created by the stroke width

                                                    const coordinates = [connec.line.x1 - lineOffset, 
                                                                        connec.line.x2 - lineOffset, 
                                                                        connec.line.y1 - lineOffset, 
                                                                        connec.line.y2 - lineOffset];
                                                    let model1 = new LineModel( { initCoords: coordinates , name: '', srcDot: connec.line.model.attributes.srcDot, destDot: connec.line.model.attributes.destDot });
                                                    //We need to set the rest of the attributes from the copied line besides the calculated properties
                                                    let attributes1 = Object.assign({}, connec.line.model.attributes);
                                                    for (let p in attributes1) {
                                                        if(p !== 'initCoords' && p !== 'srcDot' && p !== 'destDot' && p !== 'name'){
                                                            //for parameters need to be a new object other way references will be the same
                                                            if(p === 'Parameters'){
                                                                model1.attributes.Parameters = JSON.parse( JSON.stringify( connec.line.model.attributes.Parameters ));
                                                            }else{
                                                                model1.attributes[p] = attributes[p];
                                                            }
                                                        }
                                                    }
                                                    const opts2 = constants.LINE_MODEL_OPTIONS;
                                                    opts2.model = model1;
                                                    const line1 = new ConnectionArrowClass(coordinates, opts2);
                                                    // Record original points and record dot / connection-point within widget, for each end.
                                                    line1.model = model1;
                                                    // update the connection with the new widget id after it was Pasted
                                                    line1.srcId = sourceWidget;
                                                    line1.destId = destinationWidget;
                                                    line1.model.attributes.branchBooleanDisplay = connec.line.model.attributes.branchBooleanDisplay;
                                                    line1.model.attributes.destWidgetModel = destinationObj.model;
                                                    line1.model.attributes.srcWidgetModel = sourceObj.model;
                                                    line1.setCoords();
                                                    // create new VO object
                                                    const connectionVO1 = new ConnectionVO( sourceObj, destinationObj, line1.model.get('srcDot'), line1.model.get('destDot') );
                                                    line1.model.attributes.id =  connectionVO.id;
                                                    connectionVO1.srcCommand = sourceObj;
                                                    connectionVO1.destCommand = destinationObj;

                                                    if (line1.model.attributes.branchBooleanDisplay === 'true') {
                                                        sourceObj.model.attributes.trueConnector = line1.model.get('id');
                                                    }
                                                    if (line1.model.attributes.branchBooleanDisplay === 'false') {
                                                        destinationObj.model.attributes.falseConnector = line1.model.get('id');
                                                    }
                                                    connectionVO1.model = line1.model;
                                                    listService.addBehaviorConnection( connectionVO1 );

                                                }
                                            }
                                        });
                                    }
                                });
                                
                            }

                            // Keep track of newly created lines
                            newConnections.push(line);

                            listService.addWorkflowPath( connectionVO );

                            srcObj.model.attributes.widget.connection.push({line: line, end: 'A end'});
                            destObj.model.attributes.widget.connection.push({line: line, end: 'B end'});
                        }
                    }
                });
            }
        });

        undoService.add({
            undo: () => {
                // need to know what behaviors / connectors were pasted so we can delete them properly.
                pasteMap.map( (k,v) => {
                    const obj = listService.getCanvasObjectById(k);
                    listService.fcanvas.remove(obj);
                    listService.deleteWorkflowObject(obj);
                    listService.fcanvas.discardActiveGroup();
                    listService.fcanvas.renderAll();
                });

                _.each(newConnections, function (conn) {
                    self._removeConnectionArrow(conn, conn.id, constants.KIND_WORKFLOW);
                });
            },
            redo: () => {
                // PF-2704 Commenting the old implementation as destroyBehaviorObject() removes the behavior to be restored from the main behaviorObjectMap in List Service.
                // Created a map that stores the control(s) to be restored from the clipboard on the pasting process.

                // pasteMap.map( (k,v) => {
                //     // get original source object
                //     const srcVw = listService.getWorkflowStageOrComment(v);
                //
                //     const dropPos = {
                //         left: util.extractNum(srcVw.model.attributes.x) + 10,
                //         top: util.extractNum(srcVw.model.attributes.y) + 10
                //     };
                //
                //     const vw = commandGenericFactory.createWorkflowView(srcVw.model.get('factoryKey'), dropPos);
                //     vw.model = srcVw.model.clone();
                //     vw.id = k;
                //     vw.model.id = k;
                //     vw.model.set({id: k, x: dropPos.left, y: dropPos.top}, {silent:true});
                //     vw.listenTo(vw.model, 'change', vw.rerender);
                //
                //     listService.addWorkflowObject(vw);
                //     vw.render();
                //     vw.model.get('widget').connection = [];
                //     vw.model.resetLastState();
                //
                //     listService.fcanvas.renderAll();
                // });

                pastedWorkflowMap.map( (control,key) => {
                        control.listenTo(control.model, 'change', control.rerender);
                        listService.addWorkflowObject(control);
                        control.render();
                        control.model.get('widget').connection = [];
                        control.model.resetLastState();

                        listService.fcanvas.renderAll();
                });

                _.each(newConnections, function (conn) {
                    const srcObjId = conn.model.get('srcWidgetModel').attributes.id;
                    const destObjId = conn.model.get('destWidgetModel').attributes.id;

                    const srcObj = listService.getWorkflowStageOrComment(srcObjId);
                    const destObj = listService.getWorkflowStageOrComment(destObjId);

                    // create new VO object
                    const connectionVO = new ConnectionVO( srcObj, destObj, conn.model.get('srcDot'), conn.model.get('destDot') );
                   // conn.model.attributes.id =  connectionVO.id;
                    connectionVO.id = conn.model.get('id');
                    connectionVO.model = conn.model;

                    srcObj.model.attributes.widget.connection.push({line: conn, end: 'A end'});
                    destObj.model.attributes.widget.connection.push({line: conn, end: 'B end'});

                    listService.addWorkflowPath( connectionVO );
                    // check current mainKind
                    if (listService.mainKind === constants.KIND_WORKFLOW) {
                        conn.left = conn.x1 < conn.x2 ? conn.x1 : conn.x2;
                        conn.top = conn.y1 < conn.y2 ? conn.y1 : conn.y2;
                        conn.width = Math.abs(conn.x2 - conn.x1);
                        conn.height = Math.abs(conn.y1 - conn.y2);

                        listService.fcanvas.add(conn);
                        conn.setCoords();
                    }
                });

            }
        }, textConstants.UNDO_PASTE);

        let group;
        let objs = [];
        pasteMap.map( (k,v) => {
            let obj = connectionController.findWidgetById(k);
            objs.push(obj);

            const cmdObj = listService.getWorkflowStageOrComment(k);
            cmdObj.model.resetLastState();
        });


        _.each(newConnections, function (conn) {
            objs.push(conn);
        });

        if (objs.length > 1) {
            // They're on the canvas: programatically select them.
            objectUtil.selectCanvasObjects(canvas, objs);
        }

         //PF-2391 allow multiple pasting works as cascade
        this.copySelectedWorkflowObjects();
    }


    //==================================================
    // Clear any selections. Then add each control of
    // current page to selection set, lighting its
    // selection border.
    //==================================================
    selectAll() {
        listService.clearSelected();

        listService.getPageControls(listService.currentPageId).forEach((v, id) => {

            // PF-2693 If there is a group id, then don't select the controls inside the group. Just the group itself.
            if (this.isControlMemberOfAGroup(v)) {
                return;
            }
            listService.addToSelected(id);
            focusController.selectionRectangle(id, true);
        });
    }

    isControlMemberOfAGroup(control){
        return control['_groupId'];
    }

     
    //==================================================
    // Clear any selections on the canvas.
    // Get all the fabric's objects  
    // Set a new group and add all objects to the group.
    //==================================================
    selectAllCanvasObjects(){
        listService.fcanvas.deactivateAll().renderAll();

        var objs = listService.fcanvas.getObjects().reduce(function(filtered,o) {
            if(o.model){
                // PF-2322: Marking all canvas element as active
                o.set('active', true);
                filtered.push(o);
            }
            return filtered;
          },[]);

        var group = new fabric.Group(objs, {
            originX: 'left',
            originY: 'top'
          });
        
        listService.fcanvas.setActiveGroup(group.setCoords()).renderAll();
    }

}



// singleton
const crudController = new CrudController();
export default crudController;

